import TEST_SET_1 from './Test Set 1';

const SET_DATA = [TEST_SET_1];

export default SET_DATA;
